var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRefund(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 8.837H1.875A1.868 1.868 0 0 0 0 10.697v7.443C0 19.167.84 20 1.875 20h11.25A1.868 1.868 0 0 0 15 18.14v-7.442c0-1.028-.84-1.86-1.875-1.86m0 5.58H1.875v-2.79h11.25m-.938-8.372v4.651h-1.406V4.651H5.512l2.27 2.26-.995.996-3.974-3.954L6.787 0l.994.995-2.268 2.26h6.675z",
    id: "x6z6mxc6ha"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f87r66aq2b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x6z6mxc6ha"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#x6z6mxc6ha"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f87r66aq2b)",
    fill: "#140D40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2 0h20v20H-2z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefund);
export default __webpack_public_path__ + "static/media/icon-refund.bd424047f70ee870c44b8ad1640a3e14.svg";
export { ForwardRef as ReactComponent };